import React, { useState } from 'react';
import './Common.css';
import { useAuth } from '../../AuthContext';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar';
import Footer from "../../Footer";

const JobSeekers = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    const handleTakeAssessment = () => {
        if (user) {
            navigate('/quiz-selection');
        } else {
            navigate('/login');
        }
    };

    return (
        <div className="page">
            <Navbar />
            <div className="hero-section">
                <img
                    src="https://www.creativefabrica.com/wp-content/uploads/2021/07/17/Watercolor-city-hand-drawn-landscape-Graphics-14836929-1-1-580x401.jpg" // Replace with your image
                    alt="JobSeekers Hero"
                    className="hero-image"
                />
                <h1>Job Seekers</h1>
            </div>

            <div className="tab-content">
                {(
                    <div>
                        <h2>Subjectivity to Objectivity</h2>
                        <p>Empower CHRO to make unbiased informed decision, cultivate high performance culture, Future-proof
                            organization by early identification, nurturing potential leaders and avoiding potential ethical
                            and moral challenges.
                        </p>
                    </div>
                )}

            </div>
            <div className="take-assessment-container">
                <button className="take-assessment-btn" onClick={handleTakeAssessment}>
                    Take Assessment
                    <svg className="icon" viewBox="0 0 24 24" fill="currentColor">
                        <path
                            fillRule="evenodd"
                            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                            clipRule="evenodd"
                        ></path>
                    </svg>
                </button>
            </div>
            <Footer />
        </div>
    );
};

export default JobSeekers;